<template>
    <ModalContainer>
        <div class="relative bg-white rounded-lg shadow p-4 max-w-xl w-full">
            <div class="flex items-start justify-between p-4 rounded-t">
                <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
                    User Events - {{ role }}
                </h3>
                <button type="button"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center"
                    @click="close()">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 14 14">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
            </div>
            <!-- Modal body -->
            <div class="p-6 space-y-6">
                <div>
                    <h4 class="text-lg mb-2">Assigned events:</h4>
                    <div class="flex justify-between mb-1" v-for="(userEvent, index) in userEvents" :key="index">
                        <span>{{ userEvent.title }}</span>
                        <span><ButtonDanger @click="removeEvent(userEvent._id)"><DeleteIcon /></ButtonDanger></span>
                    </div>
                </div>
                <div>
                    <SelectGroup class="mb-3" name="eventId" label="Event to assign" v-model="selectedEvent" :options="events" :fielderrors="errors" />
                </div>
            </div>
            <!-- Modal Footer -->
            <div class="flex justify-end p-6 space-x-2 border-t border-gray-200 rounded-b dark:border-gray-600">
                <ButtonPrimary @click.prevent="assignUserEvent">Assign</ButtonPrimary>
            </div>
        </div>
    </ModalContainer>
</template>
<script>
import ModalContainer from '@/components/modal/ModalContainer.vue';

export default {
    props: {
        userId: {},
        events: {
            default: []
        },
        role: {},
        userEvents: {
            default: [],
        },
        close: {
            default: () => { },
        }
    },
    data() {
        return {
            selectedEvent: '',
        };
    },
    methods: {
        async assignUserEvent() {
            const response = await this.httpRequest(`/organizer/user/${this.userId}/event`, 'post', {
                data: {
                    eventId: this.selectedEvent,
                    role: this.role,
                }
            });
            if (response.result === 'success') {
                this.close(true);
            }
        },
        async removeEvent(eventId) {
            const action = async () => {
                const response = await this.httpRequest(`/organizer/user/${this.userId}/event`, 'delete', {
                    data: {
                        eventId,
                        role: this.role,
                    }
                });
                if (response.result === 'success') {
                    this.close(true);
                }
            };
            this.$root.showConfirm('Confirm remove event?', action);
        },
    },
    components: { ModalContainer }
}
</script>